import React from 'react';
import ProgressiveImage from 'react-progressive-image';
import Container from './Container';

var ProgressiveBg = function ProgressiveBg(_ref) {
  var image = _ref.image,
      imageLow = _ref.imageLow,
      imagePos = _ref.imagePos,
      bgColor = _ref.bgColor,
      style = _ref.style,
      children = _ref.children,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(ProgressiveImage, {
    src: image,
    placeholder: imageLow,
    className: className
  }, function (src) {
    return /*#__PURE__*/React.createElement(Container, {
      delay: 200,
      style: Object.assign({}, style, {
        backgroundImage: "" + (src && src !== null ? "url(" + src + ")" : style.backgroundImage),
        backgroundPosition: imagePos,
        backgroundColor: bgColor
      })
    }, children);
  });
};

ProgressiveBg.defaultProps = {
  image: null,
  imageLow: null,
  imagePos: 'center center',
  bgColor: null,
  style: {},
  children: null,
  className: undefined
};
export default ProgressiveBg;